<div class="modal-header justify-content-between">
    <h4 class="mb-0 fw-semibold">
        @if(chargeType === 'cancellationCharge') {
            Add Cancellation Charge
        } @else {
            Add Deposit Charge
        }
    </h4>
    <button
        type="button"
        class="btn btn-close"
        (click)="dismiss()"
    >
    </button>
</div>
<div class="modal-body">
    <div class="vstack gap-3">
        @if (chargeType === 'depositCharge' && canSendLinks) {
            <div class="vstack gap-3">
                <label class="form-label">
                    How will the charge be collected?
                </label>
                <div class="d-flex btn-group segmented-control justify-content-evenly" role="group">
                    <input
                        type="radio"
                        class="btn-check"
                        id="sendLink"
                        autocomplete="off"
                        [checked]="!paidInPerson"
                    >
                    <label
                        class="btn btn-outline-primary text-nowrap"
                        for="sendLink"
                        (click)="paidInPerson = false"
                    >
                        Send Link to Pay
                    </label>
                    <input
                        type="radio"
                        class="btn-check"
                        id="manualPayment"
                        autocomplete="off"
                        [checked]="paidInPerson"
                    >
                    <label
                        class="btn btn-outline-primary text-nowrap"
                        for="manualPayment"
                        (click)="paidInPerson = true"
                    >
                        In-Person Payment
                    </label>
                </div>
            </div>
        }
        @if (chargeType === 'depositCharge' && paidInPerson) {
            <div class="vstack gap-2">
                <div class="vstack">
                    <div class="hstack justify-content-between">
                        <label class="me-auto text-nowrap">
                            Mark as Paid Immediately
                        </label>
                        <div class="form-check form-switch">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                id="payNowSwitch"
                                role="switch"
                                [(ngModel)]="isImmediatelyPaid"
                            >
                        </div>
                    </div>
                    <span class="form-text">
                        Enable if the deposit is being paid right now in person, otherwise it will be marked as pending until you mark it as paid.
                    </span>
                </div>
            </div>
        }
    </div>
    <hr/>
    <app-edit-charge-form
        #editChargeForm
        [chargeType]="chargeType"
        [partySize]="partySize"
        [(charge)]="charge"
        [showExpiryTime]="!paidInPerson"
        [previousExpiryDate]="previousExpiryDate"
        [expiryMinutes]="expiryMinutes"
        (expiryMinutesChange)="expiryMinutesChanged($event)"
    >
        <div
            charge-summary
            class="bg-body-tertiary border border-light rounded-3 p-3"
        >
            <div class="vstack gap-2">
                <span class="fw-semibold fs-6">
                    @if (charge !== null) {
                        {{ null | currencyUnit : charge.amount : 'GBP' }}
                        @if (charge.isPerCover) {
                            ({{ null | currencyUnit : charge.unitAmount : 'GBP' }}
                            x
                            {{ partySize }})
                        }
                    } @else {
                        No Charge
                    }
                </span>
                <hr class="my-1"/>
                <span
                    class="px-1"
                    *ngIf="showExpiryDate"
                >
                    Booking will be cancelled if the link expires, at
                    <span class="fw-semibold">
                        {{ expiryDate | date: 'short' }}
                    </span>
                </span>
                <span
                    class="px-1"
                    *ngIf="!showExpiryDate && !paidInPerson"
                >
                    Link will never expire
                </span>
                @if (paidInPerson && isImmediatelyPaid) {
                    <span class="px-1">
                        Deposit will be marked as paid in person immediately
                    </span>
                } @else if (paidInPerson && !isImmediatelyPaid) {
                    <span class="px-1">
                        Deposit will be marked as pending (to be paid in person later)
                    </span>
                }
            </div>
        </div>
    </app-edit-charge-form>
</div>
<div class="modal-footer">
    <div class="d-flex justify-content-between w-100">
        <button
            type="button"
            class="btn btn-outline-secondary"
            (click)="dismiss()"
        >
            Cancel
        </button>
        <button
            type="button"
            class="btn btn-primary"
            (click)="save()"
            [disabled]="editChargeForm.invalid"
            data-testid="save-charge-button"
        >
            Add Charge
        </button>
    </div>
</div>
